<template>
    <div class="rythm-group" style="display:inline-block; position:relative;">
        <div v-if="hasDisplay" class='p-music' style="display:inline-block;" v-html="cleanednotes" />
        <span v-else><q-icon name="hearing" class="noprint"/></span>
        <div v-if="hasSound" style="display:inline-block; position:absolute; top:-1.5em; z-index:100;" class="noprint rythm-play-buttons">
            <q-btn-group class="btn-group noprint">
                <!-- q-btn color="primary" glossy dense icon="hearing" / -->
                <q-btn class="btn-group-btn bg-orange-3 text-white noprint" glossy dense @click="play(1)">
                    1<q-icon name="hearing" />
                    <q-tooltip>Ecouter le rythme une seule fois</q-tooltip>
                </q-btn>
                <q-btn class="btn-group-btn bg-orange-5 text-white noprint" glossy dense @click="play(2)">
                    2<q-icon name="hearing" />
                    <q-tooltip>Ecouter le rythme deux fois</q-tooltip>
                </q-btn>
                <q-btn class="btn-group-btn bg-orange-7 text-white noprint" glossy dense @click="play(4)">
                    4<q-icon name="hearing" />
                    <q-tooltip>Ecouter le rythme quatre fois</q-tooltip>
                </q-btn>
                <q-btn class="btn-group-btn bg-orange-9 text-white noprint" glossy dense @click="play(8)">
                    8<q-icon name="hearing" />
                    <q-tooltip>Ecouter le rythme huit fois</q-tooltip>
                </q-btn>
            </q-btn-group>
        </div>
    </div>
</template>

<script>
export default {
    name: "Rythme",
    props: ['notes', 'moderators'],
    data(){ return {
        hasSound: true,
        hasDisplay: true,
    }},
    methods: {
        play(repeat){
            // send an event to Partitions to play 'notes' * 'repeat'
            this.$root.$emit('djembe-play-notes', this.notes, repeat);
        }
    },
    computed: {
        cleanednotes(){
            // let tmp_notes = this.notes.replace(new RegExp(/\{.*?\}/, 'gi'), ''); // remove colors etc from the notes
            // Ex: 4t<span style='color:#07f;'>s</span>ts
            return this.notes;
        }
    },
    created: function(){
        // console.log("notes", this.notes);
        let mods = this.moderators.split('-');
        this.hasSound = mods.indexOf('nosound') == -1;
        this.hasDisplay = mods.indexOf('nodisplay') == -1;
        // console.log("Moderators:", mods);
    }
};
</script>

<style>
.btn-group-btn {
    display:none;
}
.rythm-group {
    vertical-align: top;
}
.rythm-group:hover .btn-group-btn {
    display: unset;
}
@media print {
    noprint {
        display:none;
    }
}
</style>